module.exports = __webpack_public_path__ + "static/img/network.4873ce62.svg";